import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useOrg } from '../../hooks/useOrg';
import { useNotifications } from '../NotificationSystem';
import Modal from '../ui/Modal';
import { auditVocabularyService } from '../../services/auditVocabularyService';
import '../qms/AuditQMSDetail.css';

const TABS = [
  { key: 'observatii', labelKey: 'qms:observatiiGenerale' },
  { key: 'puncte_forte', labelKey: 'qms:puncteForte' },
  { key: 'imbunatatire', labelKey: 'qms:puncteImbunatatit' },
  { key: 'oportunitati', labelKey: 'qms:oportunitatiImbunatatire' },
  { key: 'riscuri', labelKey: 'qms:riscuriIdentificate' }
];

const AuditVocabularyManager = () => {
  const { t } = useTranslation(['qms', 'common']);
  const { notify } = useNotifications();
  const { activeOrgId } = useOrg();
  const [tab, setTab] = useState('observatii');
  const [entries, setEntries] = useState([]);
  const [loading, setLoading] = useState(true);
  const [deleteId, setDeleteId] = useState(null);

  const load = async () => {
    if (!activeOrgId) {
      setEntries([]);
      setLoading(false);
      return;
    }
    setLoading(true);
    try {
      const list = await auditVocabularyService.listAll(activeOrgId);
      setEntries(list);
    } catch (e) {
      console.error(e);
      notify.error(e.message);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    load();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [activeOrgId]);

  const filtered = entries.filter((e) => e.category === tab);

  const confirmDelete = async () => {
    if (!deleteId) return;
    try {
      await auditVocabularyService.deleteEntry(activeOrgId, deleteId);
      notify.success(t('qms:entryDeleted'));
      setDeleteId(null);
      await load();
    } catch (e) {
      notify.error(e.message);
    }
  };

  if (!activeOrgId) {
    return <div className="aqd-loading">{t('qms:noOrganizationContext')}</div>;
  }

  if (loading) {
    return <div className="aqd-loading">{t('common:loading')}</div>;
  }

  return (
    <div className="audit-qms-detail" style={{ padding: '1rem' }}>
      <h2 style={{ marginBottom: '1rem' }}>{t('qms:auditVocabularyManager')}</h2>

      <div style={{ display: 'flex', flexWrap: 'wrap', gap: 8, marginBottom: 16 }}>
        {TABS.map((x) => (
          <button
            key={x.key}
            type="button"
            className={`btn btn-sm ${tab === x.key ? 'btn-primary' : 'btn-secondary'}`}
            onClick={() => setTab(x.key)}
          >
            {t(x.labelKey)}
          </button>
        ))}
      </div>

      <ul style={{ listStyle: 'none', padding: 0 }}>
        {filtered.map((en) => (
          <li
            key={en.id}
            style={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'space-between',
              padding: '10px 12px',
              border: '1px solid #e5e7eb',
              borderRadius: 8,
              marginBottom: 8
            }}
          >
            <div>
              <div>{en.text}</div>
              <small style={{ color: '#6b7280' }}>
                {t('qms:usageCount', { count: en.usageCount || 0 })}{' '}
                {en.lastUsedAt?.toDate
                  ? `• ${en.lastUsedAt.toDate().toLocaleString('ro-RO')}`
                  : ''}
              </small>
            </div>
            <button type="button" className="btn btn-sm btn-secondary" onClick={() => setDeleteId(en.id)}>
              {t('common:delete')}
            </button>
          </li>
        ))}
      </ul>

      {deleteId && (
        <Modal isOpen onClose={() => setDeleteId(null)} title={t('qms:confirmDeleteVocabularyEntry')}>
          <p>{t('qms:confirmDeleteVocabularyEntryBody')}</p>
          <div className="modal-actions" style={{ marginTop: 16 }}>
            <button type="button" className="btn btn-secondary" onClick={() => setDeleteId(null)}>
              {t('common:cancel')}
            </button>
            <button type="button" className="btn btn-primary" onClick={confirmDelete}>
              {t('common:delete')}
            </button>
          </div>
        </Modal>
      )}
    </div>
  );
};

export default AuditVocabularyManager;
